/**
 * Blockchain utility functions
 * Maps blockchain networks to their native currencies
 * 
 * NOTE: This imports from the shared config for consistency between frontend and backend
 */

import { 
  getCollectionBlockchain as sharedGetCollectionBlockchain,
  getBlockchainCurrency as sharedGetBlockchainCurrency,
  getCollectionCurrency as sharedGetCollectionCurrency,
  getCollectionDisplayName as sharedGetCollectionDisplayName,
  BLOCKCHAIN_CURRENCIES
} from '@/../../shared/config/monitored-collections';

/**
 * Get currency symbol for a blockchain
 * Uses centralized mapping from shared config
 */
export function getBlockchainCurrency(blockchain: string): string {
  return sharedGetBlockchainCurrency(blockchain);
}

/**
 * Get blockchain for a collection slug
 * Uses centralized mapping from shared config
 */
export function getCollectionBlockchain(slug: string): string {
  return sharedGetCollectionBlockchain(slug);
}

/**
 * Get currency symbol for a collection
 * Uses centralized mapping from shared config
 */
export function getCollectionCurrency(slug: string): string {
  return sharedGetCollectionCurrency(slug);
}

/**
 * Get all supported blockchain currencies
 * Useful for validation and display
 */
export function getSupportedCurrencies(): Record<string, string> {
  return BLOCKCHAIN_CURRENCIES;
}

/**
 * Get display name for a collection
 * Uses centralized mapping from shared config
 */
export function getCollectionDisplayName(slug: string): string {
  return sharedGetCollectionDisplayName(slug);
}

